import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { Counter } from '@snack-uikit/counter';
import { Sun } from '@snack-uikit/loaders';
import { ICON_POSITION } from '../../constants';
import { Variant } from './constants';
import styles from './styles.module.css';
export function getVariant({ label, icon, iconPosition }) {
    if (label && icon && iconPosition === ICON_POSITION.After) {
        return Variant.IconAfter;
    }
    if (label && icon && iconPosition === ICON_POSITION.Before) {
        return Variant.IconBefore;
    }
    if (label) {
        return Variant.LabelOnly;
    }
    return Variant.IconOnly;
}
export function getWrappedCounter({ counter, loading, disabled, counterForIcon, 'data-test-id': testId, }) {
    return typeof (counter === null || counter === void 0 ? void 0 : counter.value) === 'number' && !loading && !disabled ? (_jsx("span", { "data-test-id": `${testId !== null && testId !== void 0 ? testId : 'button'}__counter`, className: cn(counterForIcon ? styles.counterForIcon : styles.counterForLabel), children: _jsx(Counter, Object.assign({}, counter)) })) : undefined;
}
export function getWrappedIcon({ icon, iconClassName, loading, wrappedCounter }) {
    if (loading) {
        return (_jsx("span", { "data-test-id": 'loading-icon', className: iconClassName, children: _jsx(Sun, { size: 's' }) }));
    }
    if (icon) {
        return (_jsxs("span", { "data-test-id": 'icon', className: cn(iconClassName, { [styles.iconWithCounter]: Boolean(wrappedCounter) }), children: [icon, wrappedCounter] }));
    }
    return undefined;
}
export function getWrappedLabel({ label, labelClassName, wrappedCounter }) {
    return label ? (_jsxs("span", { "data-test-id": 'label', className: labelClassName, children: [label, wrappedCounter] })) : undefined;
}
export function getChildren({ icon, label, iconPosition, iconClassName, labelClassName, loading, disabled, counter, 'data-test-id': testId, }) {
    const counterForIcon = icon && (iconPosition === ICON_POSITION.After || !label);
    const wrappedCounter = getWrappedCounter({ counter, loading, disabled, counterForIcon, 'data-test-id': testId });
    const wrappedIcon = getWrappedIcon({
        icon,
        iconClassName,
        loading,
        wrappedCounter: counterForIcon ? wrappedCounter : undefined,
    });
    const wrappedLabel = getWrappedLabel({
        label,
        labelClassName,
        wrappedCounter: counterForIcon ? undefined : wrappedCounter,
    });
    switch (iconPosition) {
        case ICON_POSITION.Before: {
            return (_jsxs(_Fragment, { children: [wrappedIcon, wrappedLabel] }));
        }
        case ICON_POSITION.After:
        default: {
            return (_jsxs(_Fragment, { children: [wrappedLabel, wrappedIcon] }));
        }
    }
}
